module.exports = __webpack_public_path__ + "img/style_0_11.b5c557c4.png";